import { render, staticRenderFns } from "./empty.vue?vue&type=template&id=20c14831"
var script = {}
import style0 from "./empty.vue?vue&type=style&index=0&id=20c14831&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports